import React from "react";
import "./styles.module.css";
const Loading = ({ className = "full-screen" }) => {
  return (
    <div className={`loading`}>
      <div className="line-scale-pulse-out">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading/index.js